import React from 'react';
import classNames from 'classnames';
import Styles from './styles.less';

module.exports = React.createClass({
  displayName: 'TablePager',
  propTypes: {
    model: React.PropTypes.array,
    onPagerChange: React.PropTypes.func
  },
  getDefaultProps: function () {
    return {
      itemsPerPage: 10
    }
  },
  getInitialState() {
    return {
      list: {},
      page: 1,
      currentPage: 1,
      totalPages: 0,
      hasNextPage: 0,
      hasPreviousPage: 0
    }
  },
  componentWillReceiveProps(nextProps) {
    this.setState({
      totalPages: nextProps.totalPageCount
    })
  },
  getPrevPageClass() {
    return classNames(Styles.prevPage, this.state.currentPage == 1 ? Styles.disabled : '');
  },
  getNextPageClass() {
    return classNames(Styles.nextPage, this.state.currentPage == this.state.totalPages ? Styles.disabled : '');
  
  },
  onValueChange(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setCurrentPage(e.target.value);
  },
  onNextPage(){
    this.setCurrentPage(this.state.currentPage + 1);
  },
  onPrevPage(){
    this.setCurrentPage(this.state.currentPage - 1);
  },
  setCurrentPage(page) {
    if (!page|| page < 1 || page > this.state.totalPages) return;
    this.setState({currentPage: page});
    if(this.props.onPagerChange) this.props.onPagerChange(page);
  },
  render: require('./table-pager.rt')
});



/** WEBPACK FOOTER **
 ** ./src/table/table-pager/table-pager/table-pager.js
 **/